import { createSlice } from '@reduxjs/toolkit';
import { fetchNotices, addNotice, editNotice, removeNotice } from './actions';
import { Notice } from '../Model/Notice';

interface State { list: Notice[]; loading: boolean; error?: string; }
const initialState: State = { list: [], loading: false };

const slice = createSlice({
  name: 'notice',
  initialState,
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchNotices.pending, s => { s.loading = true; })
     .addCase(fetchNotices.fulfilled, (s, a) => { s.list = a.payload; s.loading = false; })
     .addCase(fetchNotices.rejected, (s, a) => { s.loading = false; s.error = a.error.message; })
     .addCase(addNotice.fulfilled, (s, a) => { s.list.unshift(a.payload); })
     .addCase(editNotice.fulfilled, (s, a) => { s.list = s.list.map(it => it.noticeId === a.payload.noticeId ? a.payload : it); })
     .addCase(removeNotice.fulfilled, (s, a) => { s.list = s.list.filter(it => it.noticeId !== a.meta.arg); });
  },
});
export default slice.reducer;
